import { useMutation } from '@tanstack/react-query';

import { apiResourceSchema, previewHtmlSchema } from '../common/schemas';
import { fetchJson } from '../fetch';

export const useViewQuotation = (id: number) => {
  return useMutation({
    mutationFn: async () => {
      const {
        data: { html },
      } = await fetchJson(`/quotations/${id}/view`, {
        method: 'POST',
        schema: apiResourceSchema(previewHtmlSchema),
      });

      return html;
    },
  });
};
